import React from 'react'
import Footer from '../../Footer'
import logo from '../../../img/web/splat/logo.png'
import fig1 from '../../../img/web/splat/1.png'
import fig2 from '../../../img/web/splat/2.png'
import '../Proj.css'


export default class ProjSplat extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
          
                <div className='proj-wrap-86'>
                    <div id='splat-title'>
                        <img src={logo} />
                        <p className='little-title'>Web Game design and implement</p>
                    </div>
                    <p>
                        Splat.io is a multi-player real time web game based on Nintendo game Splatoon.
                        It is a web game that allows four players to play at the same time.
                        Working in a team of three, I established the code structure and main appearance of the application,
                        including most CSS code and using the canvas component in HTML.
                    </p>
                    <p className='little-title'>How to play</p>
                    <div className='proj-fig'>
                        <img src={fig1} />
                    </div>
                    <p className='little-title'>Demonstration</p>
                    <div className='proj-content'>
                        <div className='proj-side2side'>
                            <div className='proj-fig'>
                                <img src='https://imgur.com/aexfPao.gif' />
                            </div>
                        </div>
                        <div className='proj-side2side'>
                            <div className='proj-fig'>
                                <img src='https://imgur.com/GANfOw6.gif' />
                            </div>
                        </div>
                    </div>
                    <p className='little-title'>Illustration for the result</p>
                    <div className='proj-fig'>
                        <img src={fig2} />
                    </div>
                    
                    <Footer back={true}/>
                </div>
            </div>
        )
    }
}